module.exports = __webpack_public_path__ + "static/mob-img-3-225eaed2b4f2d068f7e3ae2fe77fe2d6.png";